import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import style from './Rating.module.scss'

interface IRatingProps {
  rating: number
  color?: string
}

const Rating = ({ rating, color = '#000' }: IRatingProps) => {
  const roundedRating = Math.round(rating * 2) / 2
  const emptyPercentage = ((5 - roundedRating) / 5) * 100

  return (
    <EmptyLink color="#0053e2">
      <div className={style.rating}>
        <div className={style.empty} style={{ width: `calc(${emptyPercentage}% + 0.5px)` }}>
          {Array(5)
            .fill(1)
            .map((_, index) => (
              <i key={index} className="wm-Star" style={{ color: color }} />
            ))}
        </div>
        {Array(5)
          .fill(1)
          .map((_, index) => (
            <i key={index} className="wm-StarFill" style={{ color: color }} />
          ))}
      </div>
    </EmptyLink>
  )
}

export default Rating
